import { render, staticRenderFns } from "./ReservationsList.vue?vue&type=template&id=61ab5ec0&scoped=true"
import script from "./ReservationsList.vue?vue&type=script&lang=js"
export * from "./ReservationsList.vue?vue&type=script&lang=js"
import style0 from "./ReservationsList.vue?vue&type=style&index=0&id=61ab5ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab5ec0",
  null
  
)

export default component.exports